import React from "react";
import styles from "./cn-converter-welcome.module.scss";
import { useNavigate } from "react-router-dom";
import { constRoute } from "@utils/route";
import style from "@components/pages/project/project-name/style.module.scss";
import GoBack from "@commonComponents/go-back";

const CNConverterWelcome = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className={styles.welcomeModal}>
        <div className={styles.welcomeModalContent}>
          <h1 className={styles.welcomeModalTitle}>
            Welcome to the Concept Note Converter!
          </h1>
          <p className={styles.welcomeModalDesc}>
            This Assistant is designed to convert and upgrade your current GCF
            Concept Note to meet the requirements of the latest GCF Concept Note
            template (v3.0). Please note the following before you begin:
          </p>
          <p className={styles.welcomeModalDesc}>
            <strong>Concept Note Length:</strong> This assistant is optimized
            for Concept Notes (CNs) under 30 pages. If your CN exceeds this
            length, please expect longer processing times, particularly for the
            initial section.
          </p>
          <p className={styles.welcomeModalDesc}>
            <strong>Data Security:</strong> Your uploaded Concept Note content
            is never used for training. You can delete your project from your
            Project Library after saving, or before saving using the delete
            button under the output.
          </p>
          <p className={styles.welcomeModalDesc}>
            If you would like to get a quick video tutorial on how to use this
            Assistant, please{" "}
            <a
              href="https://www.youtube.com/watch?v=0u9h1IMZp4E"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#00B840",
                textDecoration: "underline",
              }}
            >
              click here
            </a>
            . We hope you find this experience transformative for your efforts
            to unlock climate finance, and we look forward to offering more
            helpful Assistants in the near future.
          </p>
          <p className={styles.welcomeModalGreetings}>
            Warm regards, The Janus Team
          </p>
        </div>
        <div
          className={styles.welcomeModalButton}
          onClick={() => navigate(constRoute.projectName + "/converter")}
        >
          Continue
        </div>
      </div>

      <div className={style.btnDiv}>
        <div className={style.twoBtnDiv}>
          <div className={style.goBackBtnDiv}>
            <GoBack
              onClick={constRoute?.selectFunction}
              className={style.goBtn}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CNConverterWelcome;
